import { render, staticRenderFns } from "./CompositionItems.vue?vue&type=template&id=3674abe7&scoped=true&"
import script from "./CompositionItems.vue?vue&type=script&lang=js&"
export * from "./CompositionItems.vue?vue&type=script&lang=js&"
import style0 from "./CompositionItems.vue?vue&type=style&index=0&id=3674abe7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3674abe7",
  null
  
)

export default component.exports